import { CircularProgress } from "@mui/material";

import { NoLogoFullPage } from "@/components/noLogoFullPage";

export const LoadingClerk = (): JSX.Element => (
  <NoLogoFullPage>
    <CircularProgress size={100} sx={{ color: "white" }} />
  </NoLogoFullPage>
);
